import { render } from "./AlgoliaMenuSelect.vue?vue&type=template&id=5eb427d5"
import script from "./AlgoliaMenuSelect.vue?vue&type=script&lang=js"
export * from "./AlgoliaMenuSelect.vue?vue&type=script&lang=js"

import "./AlgoliaMenuSelect.vue?vue&type=style&index=0&id=5eb427d5&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__